// extracted by mini-css-extract-plugin
export default {"header":"NotificationView_header__uOZeF","referral":"NotificationView_referral__gQLSZ","referralText":"NotificationView_referralText__D6sh9"};